import React, { useState, useEffect } from 'react';
import api from '../../api';
import '../HomeBaseForm.css';
import '../Buttons.css';
import './SupplierVarietyManager.css';

const SupplierVarietyManager = ({ currentSupplier, selectedCrop, plants }) => {
    const [varieties, setVarieties] = useState([]);
    const [packetOptions, setPacketOptions] = useState([]);

    useEffect(() => {
        if (selectedCrop && currentSupplier?.id) {
            fetchVarieties();
        } else {
            setVarieties([]);
        }
    }, [selectedCrop, currentSupplier?.id]);

    const selectedCropName =
        plants.find(p => p.id === selectedCrop)?.name || "Unknown Crop";

    useEffect(() => {
        if (currentSupplier?.id) {
            fetchPacketOptions();
        }
    }, [currentSupplier?.id]);

    const fetchPacketOptions = async () => {
        try {
            const res = await api.get(`/supplierPrice`);
            setPacketOptions(res.data.map(p => ({
                id: p.id,                  // supplierPrice ID
                packetSizeID: p.id,  
                price: p.price,             // decimal
                label: `${p.description} ($${p.price.toFixed(2)})`
            })));
        } catch (err) {
            console.error("Error fetching packet options:", err);
        }
    };

    const fetchVarieties = async () => {
        try {
            const res = await api.get('/supplierPlantData', {
                params: {
                    supplierID: currentSupplier.id,
                    plantID: selectedCrop
                }
            });

            setVarieties(
                res.data.map(v => ({
                    ...v,
                    supplierPriceID: v.supplierPriceID,  // NEW: use this to populate dropdown
                    AvailableFlag: v.AvailableFlag
                }))
            );
        } catch (err) {
            console.error('Error fetching varieties:', err);
        }
    };
    const handleAddVariety = () => {
        const tempID = `temp-${Date.now()}`;

        setVarieties(prev => [
            ...prev,
            {
                supplierPlantID: tempID,
                variety: '',
                PacketSizeID: null,
                AvailableFlag: 1,
                isNew: true
            }
        ]);
    };

    const handleUpdateAll = async () => {
        try {
            for (const v of varieties) {
                if (v.isNew) {
                    await api.post('/supplierPlantData/add', {
                        supplierId: currentSupplier.id,
                        plantID: selectedCrop,
                        variety: v.variety,
                        availableFlag: v.AvailableFlag,
                        packetSizeID: v.PacketSizeID
                    });
                } else {
                    await api.put('/supplierPlantData', {
                        supplierPlantID: v.supplierPlantID,
                        plantID: selectedCrop,
                        variety: v.variety,
                        availableFlag: v.AvailableFlag,
                        packetSizeID: v.PacketSizeID
                    });
                }
            }

            fetchVarieties();
        } catch (err) {
            console.error('Error updating varieties:', err);
        }
    };

    return (
        <div className="variety-manager">
            {!selectedCrop ? (
                <h2>Select a crop from the sidebar to manage varieties.</h2>
            ) : (
                <>
                    <h2>Manage {selectedCropName} Varieties</h2>

                    <table className="variety-table">
                        <thead>
                            <tr>
                                <th>Variety Name</th>
                                <th>Packet Size</th>
                                <th>Available</th>
                            </tr>
                        </thead>
                        <tbody>
                            {varieties.map((v) => (
                                <tr key={v.supplierPlantID}>
                                    <td>
                                        <input
                                            type="text"
                                            value={v.variety || ''}
                                            onChange={(e) =>
                                                setVarieties(prev =>
                                                    prev.map(item =>
                                                        item.supplierPlantID === v.supplierPlantID
                                                            ? { ...item, variety: e.target.value }
                                                            : item
                                                    )
                                                )
                                            }
                                        />
                                    </td>

                                    <td>
                                        <select
                                            value={v.PacketSizeID || ''}
                                            onChange={(e) =>
                                                setVarieties(prev =>
                                                    prev.map(item =>
                                                        item.supplierPlantID === v.supplierPlantID
                                                            ? { ...item, PacketSizeID: e.target.value ? Number(e.target.value) : null }
                                                            : item
                                                    )
                                                )
                                            }
                                        >
                                            <option value="">Select a value</option> {/* default if NULL */}

                                            {packetOptions.map(opt => (
                                                <option key={opt.id} value={opt.id}>
                                                    {opt.label}
                                                </option>
                                            ))}
                                        </select>
                                    </td>

                                    <td style={{ textAlign: 'center' }}>
                                        <input
                                            type="checkbox"
                                            checked={v.AvailableFlag === true}
                                            onChange={(e) =>
                                                setVarieties(prev =>
                                                    prev.map(item =>
                                                        item.supplierPlantID === v.supplierPlantID
                                                            ? { ...item, AvailableFlag: e.target.checked ? true : false }
                                                            : item
                                                    )
                                                )
                                            }
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div style={{ marginTop: '1rem' }}>
                        <button className="button" onClick={handleAddVariety}>
                            Add Variety Row
                        </button>

                        <button
                            className="button"
                            style={{ marginLeft: '1rem' }}
                            onClick={handleUpdateAll}
                        >
                            Save Updates
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default SupplierVarietyManager;
